import React from 'react';
import { CollapseFilterWrapper } from '../../../components/sidebar-filters/CollapseFilterWrapper';
import { CloudVenDispatchTypeFilterSelect } from '../../../components/sidebar-filters/filter-select/CloudVenDispatchTypeFilterSelect';
import { ProgramFilterSelect } from '../../../components/sidebar-filters/filter-select/ProgramFilterSelect';
import { VenStatusFilterSelect } from '../../../components/sidebar-filters/filter-select/VenStatusFilterSelect';
import { useSidebarFilterOptionsContext } from '../../energyUsageData/sidebar/context/SidebarFilterOptionsContext';
import { ICloudVenSidebarFilters, useCloudVenSidebarFiltersContext } from './CloudVenSidebarFiltersContext';

export const CloudVensFilterKeys = {
    // Filters
    program_id: 'program_id',
    status: 'status',
    dispatch_type: 'dispatch_type',
} as const;

export type TCloudVensFilterKey = (typeof CloudVensFilterKeys)[keyof typeof CloudVensFilterKeys];

export const CloudVenFilterLabels = {
    [CloudVensFilterKeys.program_id]: 'Program',
    [CloudVensFilterKeys.status]: 'VEN Status',
    [CloudVensFilterKeys.dispatch_type]: 'Dispatch Type',
} as const;

interface ICloudVenSidebarFiltersProps {
    onFilterChange: (filters: ICloudVenSidebarFilters) => void;
}

export const CloudVenSidebarFilters: React.FC<ICloudVenSidebarFiltersProps> = ({ onFilterChange }) => {
    const { filters, handleFilterChange } = useCloudVenSidebarFiltersContext();
    const { isLoading: isFiltersLoading, programOptions, venStatusOptions, cloudVenDispatchTypeOptions } = useSidebarFilterOptionsContext();

    const handleCloudVenFilterChange = (key: string, value: unknown) => {
        handleFilterChange(key, value);
        onFilterChange({ ...filters, [key]: value });
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'auto' }}>
            {/* Filters */}
            <CollapseFilterWrapper label="Filters">
                <ProgramFilterSelect
                    label={CloudVenFilterLabels[CloudVensFilterKeys.program_id]}
                    value={filters[CloudVensFilterKeys.program_id]}
                    onChange={val => handleCloudVenFilterChange(CloudVensFilterKeys.program_id, val)}
                    isLoading={isFiltersLoading}
                    options={programOptions}
                />
                <VenStatusFilterSelect
                    label={CloudVenFilterLabels[CloudVensFilterKeys.status]}
                    value={filters[CloudVensFilterKeys.status] || null}
                    onChange={value => handleFilterChange(CloudVensFilterKeys.status, value)}
                    options={venStatusOptions}
                />
                <CloudVenDispatchTypeFilterSelect
                    label={CloudVenFilterLabels[CloudVensFilterKeys.dispatch_type]}
                    value={filters[CloudVensFilterKeys.dispatch_type] || null}
                    onChange={value => handleCloudVenFilterChange(CloudVensFilterKeys.dispatch_type, value)}
                    options={cloudVenDispatchTypeOptions}
                />
            </CollapseFilterWrapper>
        </div>
    );
};
